import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import InfoBanner from 'components/application/InfoBanner';

export default function NoUserPermissionsSetBanner({ divisionName }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'users.NoUserPermissionsSetBanner',
  });

  return (
    <InfoBanner flavour='warning' size='medium' title={i18nT('title')}>
      <div>
        {i18nT('description', {
          divisionName,
          interpolation: { escapeValue: false },
        })}
      </div>
      <div>{i18nT('contact')}</div>
    </InfoBanner>
  );
}

NoUserPermissionsSetBanner.propTypes = {
  divisionName: PropTypes.string.isRequired,
};
